import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import moment from 'moment'
import chunk from 'lodash/chunk'
// import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
// import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
class SeasonDataView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      slideIndex: 0,
      panelWidth: 0
    }
    this.speciesDict = this.toIdObject(props.species)
    this.weaponsDict = this.toIdObject(props.weaponTypes)
    this.huntTypesDict = this.toIdObject(props.huntTypes)
    this.sliderRef = React.createRef()
    this.scrollTo = this.scrollTo.bind(this)
  }

  componentDidMount() {
    const panelWidth = this.sliderRef.current.offsetWidth + (this.sliderRef.current.offsetWidth - 660)
    this.setState({ panelWidth, totalIndexes: chunk(this.props.unitData.seasonDates, 2).length - 1 })
  }

  toIdObject(arr) {
    const obj = {}
    arr.forEach(entry => obj[entry.id] = entry)
    return obj
  }

  scrollTo(px) {
    const sliderRef = this.sliderRef.current
    sliderRef.scrollLeft = Math.max(0, Math.min(px, sliderRef.scrollLeftMax))
  }

  makeSeasonEntries() {
    const { unitData } = this.props,
      { seasonDates } = unitData,
      { speciesDict, huntTypesDict, weaponsDict } = this
    return seasonDates.map((dateEntry, idx) => {
      const huntType = huntTypesDict[dateEntry.huntTypeId],
        startDate = new moment(dateEntry.seasonStart).format('MMM DD'),
        endDate = new moment(dateEntry.seasonEnd).format('MMM DD'),
        weaponIcon = weaponsDict[dateEntry.weaponId].iconUrl
      return (
        <div className='hunt-modal-season-box' key={dateEntry.id} >
          <div className='hunt-modal-season-top-matter'>
            <div className='hunt-modal-season-title'>
              <p className='vertical-center'>
                {`${dateEntry.year} ${dateEntry.tagName}`}
              </p>
            </div>
            <div className='hunt-modal-season-species-icon vertical-center'
              style={{
                backgroundImage: `url(${speciesDict[dateEntry.speciesId].iconUrl})`
              }}></div>
          </div>
          <div className='hunt-modal-season-box-content'>
            <div className='hunt-modal-season-entry-row'>
              <p className='hunt-modal-season-entry-name'>HUNT TYPE</p>
              <p className='hunt-modal-season-entry-data'>{huntType.name}</p>
            </div>
            {
              dateEntry.huntNumber ? (
                <div className='hunt-modal-season-entry-row'>
                  <p className='hunt-modal-season-entry-name'>HUNT NO.</p>
                  <p className='hunt-modal-season-entry-data'>{dateEntry.huntNumber}</p>
                </div>
              ) : null
            }
            {
              (dateEntry.eitherResidencyTags || dateEntry.nonResidentTags || dateEntry.residentTags) ?
                (
                  <div className='hunt-modal-season-entry-row'>
                    <p className='hunt-modal-season-entry-name'>QUOTAS</p>
                    <div>
                      {dateEntry.eitherResidencyTags ? <p className='hunt-modal-season-entry-data'>{`Either Residency Tags: ${dateEntry.eitherResidencyTags}`}</p> : null}
                      {dateEntry.residentTags ? <p className='hunt-modal-season-entry-data'>{`Resident Tags: ${dateEntry.residentTags}`}</p> : null}
                      {dateEntry.nonResidentTags ? <p className='hunt-modal-season-entry-data'>{`Non-Resident Tags: ${dateEntry.nonResidentTags}`}</p> : null}
                    </div>
                  </div>
                ) : null
            }
            <div className='hunt-modal-season-entry-row'>
              <p className='hunt-modal-season-entry-name'>SEASON DATES</p>
              <div className='hunt-modal-season-entry-data'>
                <p className='hunt-modal-season-date-text'>{`${startDate} - ${endDate}`}</p>
                <p>{dateEntry.sex}</p>
              </div>
              <div className='hunt-modal-season-weapon-icon'
                style={{
                  backgroundImage: `url(${weaponIcon})`
                }}></div>
            </div>
            <div className='hunt-modal-season-entry-row'>
              <p className='hunt-modal-season-entry-name'>NOTES</p>
              <div>
                {
                  dateEntry.note1 ? <p className='hunt-modal-season-entry-data'>{dateEntry.note1}</p> : null
                }
                {
                  dateEntry.note2 ? <p className='hunt-modal-season-entry-data'>{dateEntry.note2}</p> : null
                }
              </div>
            </div>
          </div>
        </div >
      )
    })
  }

  render() {
    const { unitData, loading } = this.props,
      { sliderRef } = this
    if (!unitData || loading) {
      return null
    }
    const { seasonDates } = unitData,
      slideIndexes = chunk(seasonDates, 2)

    return (
      <div className='hunt-modal-season-container'>
        <div className='hunt-modal-season-slider' ref={this.sliderRef}>
          {this.makeSeasonEntries()}
        </div>
        {
          seasonDates.length > 2 ? (
            <div className='hunt-modal-season-buttons'>
              <div>
                <ChevronLeftIcon className='vertical-center'
                  onClick={() => {
                    this.scrollTo(sliderRef.current.scrollLeft - this.state.panelWidth)
                    this.setState({ slideIndex: Math.max(0, this.state.slideIndex - 1) })
                  }} />
              </div>
              {
                sliderRef.current ? (
                  slideIndexes.map((arr, idx) => {
                    return (
                      <div className='hunt-modal-season-button vertical-center' key={`season-button-${idx}`}
                        style={{ backgroundColor: this.state.slideIndex === idx ? '#ff6800' : '' }}
                        onClick={() => {
                          const target = idx * this.state.panelWidth
                          sliderRef.current.scrollLeft = Math.max(0, Math.min(target, sliderRef.current.scrollLeftMax))
                          this.setState({ slideIndex: idx })
                        }}>
                        <p className='vertical-center' style={{ textAlign: 'center' }}>
                          {idx + 1}
                        </p>
                      </div>
                    )
                  })
                ) : null
              }
              <div>
                <ChevronRightIcon className='vertical-center'
                  onClick={() => {
                    this.scrollTo(sliderRef.current.scrollLeft + this.state.panelWidth)
                    this.setState({ slideIndex: Math.min(this.state.totalIndexes, this.state.slideIndex + 1) })
                  }} />
              </div>
            </div>
          ) : null
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  loading: state.loading,
  huntTypes: state.huntTypes,
  species: state.species,
  weaponTypes: state.weaponTypes
})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(SeasonDataView)
